import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';

import {AgmCoreModule} from '@agm/core';
import {AgmSnazzyInfoWindowModule} from '@agm/snazzy-info-window';
import {CalendarModule} from 'angular-calendar';

import {routing} from './app.routing';
import {AppSettings} from './app.settings';

import {AppComponent} from './app.component';
import {NotFoundComponent} from './pages/errors/not-found/not-found.component';

import {environment} from '../environments/environment';

import {AngularFireModule} from 'angularfire2';
import {AngularFireAuthModule} from 'angularfire2/auth';
// import { AngularFireDatabaseModule } from 'angularfire2/database';
import {AngularFirestoreModule} from 'angularfire2/firestore';

import {
    AuthGuard,
    UserDataService,
    // OrgDataService
} from './shared';

const firebaseconfig = environment.firebaseconfig;

// Application wide providers
const APP_PROVIDERS = [
    AppSettings,
    AuthGuard,
    UserDataService,
    // OrgDataService
];

@NgModule({
    declarations: [AppComponent, NotFoundComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyDKpl4O_vyLgclfvPmCnvYEPUj4yBJIjRI',
            libraries: ['places', 'geometry'],
        }),
        AgmSnazzyInfoWindowModule,
        CalendarModule.forRoot(),
        AngularFireAuthModule,
        AngularFirestoreModule,
        AngularFireModule.initializeApp(firebaseconfig),
        routing,
    ],
    providers: [APP_PROVIDERS],
    bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts